export const ADMIN = 'RubiconAdmin';
export const ADMIN_VENDOR = 'RubiconAdminVendor';
export const SUPER_ADMIN = "RubiconSuperAdmin";
export const VENDOR = 'RubiconHauler';
export const VENDOR_MANAGER = 'RubiconVendorManagement';
